/**
 * @generated SignedSource<<0528aaaab050ab0c28e79efafbdb726a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedFavoriteItem_item$data = {
  readonly isNewListing: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"FavoritesItem_item">;
  readonly " $fragmentType": "SharedFavoriteItem_item";
};
export type SharedFavoriteItem_item$key = {
  readonly " $data"?: SharedFavoriteItem_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedFavoriteItem_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedFavoriteItem_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isNewListing",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FavoritesItem_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "107724c2e4036938e6bb4db1138d8f23";

export default node;
